import React from 'react';
import { observer } from 'mobx-react';
import BillListService from '../services/BillListService';
import BillList from './BillList';
import { toJS } from 'mobx';

const BillListContainer = () => (
  <BillList
    bills={toJS(BillListService.bills)}
    pagination={BillListService.pagination}
    fetching={BillListService.fetch.fetching}
    onChange={BillListService.handleChange}
    onAction={BillListService.handleAction}
    selectedBills={toJS(BillListService.selectedBills)}
    sortedInfo={BillListService.sort}
  />
);

export default observer(BillListContainer);
